<template>
  <b-container class="p-3">
    <b-row>
      <b-col cols="2">
        <b-img
          :src="user_picture"
          class="pp-img"
        />
        <label for="file-upload" class="pp-btn">
          Change Photo
        </label>
        <input name="user_picture" id="file-upload" type="file" @change="appendFormData" style="display: none;" />
      </b-col>

      <b-col>
        <b-row>
          <b-col cols="4">
            <b-form-input
              v-model="user_data.first_name"
              id="input-first-name"
              placeholder="First Name"
              type="text"
            />
          </b-col>
          <b-col cols="4">
            <b-form-input
              v-model="user_data.last_name"
              id="input-last-name"
              placeholder="Last Name"
              type="text"
            />
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="8">
            <InputTextarea
              @passToParent="childData"
              :key="keyComponent"
              :val="user_data.description"
              id="description"
              text="About me"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-row>
          <b-col cols="6">
            <InputSelect
              @passToParent="childData"
              :key="keyComponent"
              :val="user_data.gender"
              id="gender"
              text="Gender"
              :options="gender_options"
            />
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <InputDate
                @passToParent="childData"
                :key="keyComponent"
                :val="user_data.dob"
                id="dob"
                text="Date of Birth"
                :config="dob_config"
              />
          </b-col>
          <b-col>
            <b-form-input
              v-model="user_data.phone"
              id="input-phone"
              placeholder="Phone Number"
              type="text"
              @keypress="numberOnly($event)"
            />
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <InputSelect
              @passToParent="childData"
              :key="keyComponent"
              :val="user_data.language"
              id="language"
              text="Language"
              :options="language_options"
            />
          </b-col>
          <b-col>
            <InputSelect
              @passToParent="childData"
              :key="keyComponent"
              :val="user_data.occupation"
              id="occupation"
              text="Occupation"
              :options="occupation_options"
            />
          </b-col>
        </b-row>
      </b-col>

      <b-col>
        <label :for="'input-interest'">Interest</label>
        <b-form-checkbox-group
          v-model="user_data.interest"
          :id="'input-interest'"
          :options="interest_options"
          switches
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="2">
        <b-button variant="primary" block @click="updateCS" :disabled="update_button_state">
          Update
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies
import moment from 'moment'
import swal from 'sweetalert'

// custom component
import InputDate from '@/templates/InputDate'
import InputSelect from '@/templates/InputSelect'
import InputTextarea from '@/templates/InputTextarea'
import InputSwitches from '@/templates/InputSwitches'

// api call
import UserAPI from '@/api/UserAPI'
import UserFileAPI from '@/api/UserFileAPI'
import AdminInterestAPI from '@/api/AdminInterestAPI'
import AuthenticationAPI from '@/api/AuthenticationAPI'

export default {
  name: 'MyAccount_Settings_Profile',
  props: ['user'],
  components: {
    InputDate,
    InputSelect,
    InputTextarea,
    InputSwitches
  },
  data () {
    return {
      user_data: {
        // get from DB
        language: null,
        occupation: null,
        interest: null
      },
      user_picture: '',
      formData: new FormData(),

      dob_config: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        maxDate: new Date()
      },
      gender_options: [
        { value: null, text: 'Gender', disabled: true },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      language_options: [
        { value: null, text: 'Language', disabled: true },
        { value: 'en', text: 'English' },
        { value: 'id', text: 'Bahasa' }
      ],
      occupation_options: [
        { value: null, text: 'Occupation', disabled: true },
        { value: 'student', text: 'Student' },
        { value: 'tour_guide', text: 'Tour Guide' },
        { value: 'engineers', text: 'Engineers' },
        { value: 'consultant', text: 'Consultant' },
        { value: 'managers', text: 'Managers' }
      ],
      interest_options: [],

      keyComponent: 0,
      update_button_state: false,
      errors: []
    }
  },
  mounted: function () {
    this.getInterest()
    this.getCS()
  },
  methods: {
    // FILES
    createImage: function (file) {
      var reader = new FileReader()
      var self = this

      reader.onload = (e) => {
        self.user_picture = e.target.result
      }
      reader.readAsDataURL(file)
    },
    appendFormData: function (e) {
      let fileList = e.target.files

      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      if (e.target.name === 'user_picture') {
        this.createImage(files[0])
      }

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          if (this.formData.get(e.target.name)) {
            this.formData.set(e.target.name, fileList[x], fileList[x].name)
          } else {
            this.formData.append(e.target.name, fileList[x], fileList[x].name)
          }
        })
    },
    // END FILES

    // PREREQUISITES
    childData (id, value) {
      // catch value from custom form template
      this.user_data[id] = value
    },
    forceRerender: function () {
      // value nya gak auto ke update stlh di ambil dr DB
      this.keyComponent += 1
    },
    numberOnly: function (evt) {
      evt = (evt) || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // END PREREQUISITES

    // HTTP REQUEST
    getInterest: async function () {
      let fetchedRecord = await AdminInterestAPI.fetchAll()

      fetchedRecord.data.interest.forEach(interest => {
        this.interest_options.push(
          { value: interest._id, text: interest.interest }
        )
      })
    },
    getCS: async function () {
      let response = await UserAPI.getCS({
        _id: this.user._id
      })

      if (response.data.user.picture) {
        this.user_picture = this.globalProp.vs + 'u/' + response.data.user._id + '/user_picture/' + response.data.user.picture.file_name + '.' + response.data.user.picture.file_type
      } else {
        this.user_picture = require('@/assets/img/blank-profile.png')
      }

      // insert user data to data ()
      Object.keys(response.data.user).forEach(element => {
        this.user_data[element] = response.data.user[element]

        if (element === 'dob') {
          this.user_data['dob'] = moment(this.user_data.dob).format('DD/MM/YYYY')
          // this.user_data['dob'] = moment(new Date(this.user_data['dob'])).format('DD/MM/YYYY')
        }
      })

      // force update input's component
      this.forceRerender()
    },
    updateCS: async function () {
      let self = this
      this.update_button_state = true

      // validasi
      let flag = 0
      if (self.user_data.dob === 'Invalid date' || !self.user_data.dob) flag++

      if (flag !== 0) {
        swal({
          title: 'Please fill your Date of Birth!',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.update_button_state = false
      } else {
        try {
          await UserAPI.updateCS(self.user_data)
          self.formData.append('user_id', self.user_data._id)

          if (self.formData.get('user_picture') || self.formData.get('file_passport') || self.formData.get('file_certificate')) {
            await UserFileAPI.upload(self.formData)
            self.updateSessionData({ sg_user_id: self.user_data._id })
            // need force update component or reload page
          }
          swal({
            title: 'Profile successfully updated!',
            icon: 'success',
            button: {
              text: 'Ok'
            }
          })
          setTimeout(() => {
            this.$router.go()
          }, 2000)
        } catch (error) {
          swal({
            title: 'Update profile error!',
            icon: 'error',
            button: {
              text: 'Ok'
            }
          })

          this.update_button_state = false
        }
      }

      /* self.formData.append('user_id', self.user_data._id)

      if (self.formData.get('user_picture') || self.formData.get('file_passport') || self.formData.get('file_certificate')) {
        try {
          await UserFileAPI.upload(self.formData)
          self.updateSessionData({ sg_user_id: self.user_data._id })
          // need force update component or reload page
        } catch (error) {
          swal({
            title: 'Upload files error!',
            icon: 'error',
            button: {
              text: 'Ok'
            }
          })
        }
      } else {
        swal({
          title: 'Profile successfully updated!',
          icon: 'success',
          button: {
            text: 'Ok'
          }
        })
      } */
    },
    updateSessionData: async function (params) {
      return new Promise((resolve) => {
        AuthenticationAPI.updateSessionData(params).then((response) => {
          if (response.data.token) this.$session.set(`jwt`, response.data.token)
          resolve()
        })
      })
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
img {
  width: 100%;
  margin: auto;
  display: block;
}

.pp-img {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.pp-btn {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  width: 100%;
  text-align: center;

  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.pp-btn:hover {
  background-color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Settings/Profile/Profile.vue